import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _conversionRateRequest = {};
var _conversionRateResponse = { rateTimestamp: 'google.protobuf.Timestamp' };
var _convertCurrencyRequest = {};
var _convertCurrencyResponse = { rateTimestamp: 'google.protobuf.Timestamp' };
var _listCurrenciesRequest = {};
var _listCurrenciesResponse = {};
function resolveComWixpressCurrencyConverterApiV1CurrencyConverterUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/currency-converter',
                destPath: '',
            },
        ],
        'cronulla-jobs._base_domain_': [
            {
                srcPath: '/currency-converter-bo',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/currency_converter',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/currency-converter',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns all currencies currently supported by Wix. */
export function listCurrencies(payload) {
    var _a = serializer(_listCurrenciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCurrenciesResponse, {}).fromJSON;
    function __listCurrencies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.currency_converter.v1.currency_rate',
            method: 'GET',
            methodFqn: 'com.wixpress.currency.converter.api.v1.CurrencyConverter.ListCurrencies',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCurrencyConverterApiV1CurrencyConverterUrl({
                protoPath: '/v1/currencies',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCurrencies.fromReq = fromReq;
    __listCurrencies.__isAmbassador = true;
    return __listCurrencies;
}
/** Returns a list of converted amounts, from the original (from) currency to the target (to) currency. */
export function convertCurrency(payload) {
    var _a = serializer(_convertCurrencyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_convertCurrencyResponse, {}).fromJSON;
    function __convertCurrency(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.currency_converter.v1.currency_rate',
            method: 'POST',
            methodFqn: 'com.wixpress.currency.converter.api.v1.CurrencyConverter.ConvertCurrency',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCurrencyConverterApiV1CurrencyConverterUrl({
                protoPath: '/v1/currencies/amounts/{from}/convert/{to}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __convertCurrency.fromReq = fromReq;
    __convertCurrency.__isAmbassador = true;
    return __convertCurrency;
}
/** Returns the conversion rate between 2 currencies. */
export function conversionRate(payload) {
    var _a = serializer(_conversionRateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_conversionRateResponse, {}).fromJSON;
    function __conversionRate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecommerce.currency_converter.v1.currency_rate',
            method: 'GET',
            methodFqn: 'com.wixpress.currency.converter.api.v1.CurrencyConverter.ConversionRate',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCurrencyConverterApiV1CurrencyConverterUrl({
                protoPath: '/v1/currencies/rate/{from}/convert/{to}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __conversionRate.fromReq = fromReq;
    __conversionRate.__isAmbassador = true;
    return __conversionRate;
}
//# sourceMappingURL=http.impl.js.map